import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { UploadSignatureLibraryComponent } from 'upload-signature-library';
import * as i1 from '@angular/material/dialog';
import * as i2 from '@angular/forms';
import * as i3 from 'primeng/button';
import * as i4 from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { PrimengLibraryModule } from 'primeng-library';

class LibPictureUploadService {
    constructor() { }
}
LibPictureUploadService.ɵfac = function LibPictureUploadService_Factory(t) { return new (t || LibPictureUploadService)(); };
LibPictureUploadService.ɵprov = i0.ɵɵdefineInjectable({ token: LibPictureUploadService, factory: LibPictureUploadService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPictureUploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function LibPictureUploadComponent_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.signatureImage, i0.ɵɵsanitizeUrl);
} }
class LibPictureUploadComponent {
    constructor(dialog, fb) {
        this.dialog = dialog;
        this.fb = fb;
    }
    ngOnInit() {
        this.group.addControl(this.inputParams.name, this.fb.control(this.inputParams.value));
    }
    uploadSignatureImage() {
        const dialogRef = this.dialog.open(UploadSignatureLibraryComponent, {
            panelClass: 'custom-dialog'
        });
        dialogRef.afterClosed().subscribe(result => {
            this.sessionpicimage = sessionStorage.setItem("SesionpicValue", this.signatureImage);
            const file = this.dataURItoBlob(result);
            //  console.dir("blob", file);
            let reader = new FileReader();
            let self = this;
            reader.readAsDataURL(file);
            reader.onload = function () {
                self.signatureImage = reader.result;
            };
            reader.onerror = function (error) {
            };
            //this.signatureImageForm = new FormData();
            //this.signatureImageForm.append("file", file, "pic.png");
            this.group.controls[this.inputParams.name].setValue(file);
        });
    }
    dataURItoBlob(dataURI) {
        const binary = atob(dataURI.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
            type: 'image/png',
        });
    }
}
LibPictureUploadComponent.ɵfac = function LibPictureUploadComponent_Factory(t) { return new (t || LibPictureUploadComponent)(i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i2.FormBuilder)); };
LibPictureUploadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibPictureUploadComponent, selectors: [["lib-picture-upload"]], inputs: { group: "group", inputParams: "inputParams" }, decls: 5, vars: 1, consts: [[1, "row"], [1, "col-4", "linehgt10"], ["pButton", "", "type", "button", "label", "inputParams.label", "title", ".png only", 3, "click"], [1, "col-8", "linehgt10"], ["class", "signatureImageBox", 3, "src", 4, "ngIf"], [1, "signatureImageBox", 3, "src"]], template: function LibPictureUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "button", 2);
        i0.ɵɵlistener("click", function LibPictureUploadComponent_Template_button_click_2_listener() { return ctx.uploadSignatureImage(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, LibPictureUploadComponent_img_4_Template, 1, 1, "img", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.signatureImage);
    } }, directives: [i3.ButtonDirective, i4.NgIf], styles: [".signatureImageBox[_ngcontent-%COMP%]{border:1px dotted;max-width:100px;max-height:100px;padding:5px;margin-bottom:5px;margin-top:35px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPictureUploadComponent, [{
        type: Component,
        args: [{
                selector: 'lib-picture-upload',
                templateUrl: "./lib-picture-upload.component.html",
                styleUrls: ["./lib-picture-upload.component.scss"],
            }]
    }], function () { return [{ type: i1.MatDialog }, { type: i2.FormBuilder }]; }, { group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }] }); })();

class LibPictureUploadModule {
}
LibPictureUploadModule.ɵfac = function LibPictureUploadModule_Factory(t) { return new (t || LibPictureUploadModule)(); };
LibPictureUploadModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibPictureUploadModule });
LibPictureUploadModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            BrowserModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibPictureUploadModule, { declarations: [LibPictureUploadComponent], imports: [BrowserModule,
        PrimengLibraryModule], exports: [LibPictureUploadComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibPictureUploadModule, [{
        type: NgModule,
        args: [{
                declarations: [LibPictureUploadComponent],
                imports: [
                    BrowserModule,
                    PrimengLibraryModule
                ],
                exports: [LibPictureUploadComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-picture-upload
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibPictureUploadComponent, LibPictureUploadModule, LibPictureUploadService };
//# sourceMappingURL=lib-picture-upload.js.map
